import { cn } from "@/lib/utils";
import { RichLabel } from "@patient-watch/forms";
import type { ReactNode } from "react";

/** Strip seed markdown-style markers for plain-text contexts (for example img alt text). */
export function stripInputLabelMarkup(label: string): string {
    return label
        .replace(/\+\+([^+]+)\+\+/g, "$1")
        .replace(/\*\*([^*]+)\*\*/g, "$1")
        .replace(/\*([^*\n]+)\*/g, "$1")
        .replace(/_([^_\n]+)_/g, "$1")
        .replace(/<u>([^<]*)<\/u>/gi, "$1");
}

function renderLabelContent(children: ReactNode): ReactNode {
    if (typeof children === "string") {
        return <RichLabel>{children}</RichLabel>;
    }
    if (typeof children === "number") {
        return <RichLabel>{String(children)}</RichLabel>;
    }
    return children;
}

export interface EntryValueLabelProps {
    children: React.ReactNode;
    size?: "sm" | "md" | "lg";
}

export const EntryValueLabel = ({ children, size = "md" }: EntryValueLabelProps) => {
    return (
        <span
            className={cn(
                "min-w-16 font-normal text-slate-600",
                size === "sm" && "text-sm",
                size === "md" && "text-md",
                size === "lg" && "text-md"
            )}
        >
            {renderLabelContent(children)}
        </span>
    );
};
